import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { all_routes } from "../../Router/all_routes";

export const SerialBarcodeReport = () => {
  const navigate = useNavigate();

  useEffect(() => {
    toast.info(
      "Serial barcode label generation is now integrated directly into Products and Product Actions."
    );
    navigate(all_routes.productlist || "/products", { replace: true });
  }, [navigate]);

  return null;
};

export default SerialBarcodeReport;
